import React, { useEffect, useState } from "react";
import {  Col, Typography , Form,  Input,  Modal, theme,  Row,  Divider, } from "antd";
import ErrorMessages from "../../common/ErrorMessages";

export default function PurchaseCTTStockListViewModal(props) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const { open, onClose, target, onUpdate } = props;
  const [errorMessages, setErrorMessages] = useState(null);

  useEffect(() => {
    if (open) {
      setErrorMessages(null)
      form.resetFields();
      if (target) {
        form.setFieldsValue(target);
      }
    }
  }, [open]);

  const {
    token: { colorWarning, colorSuccess },
  } = theme.useToken();

  const handleOK = async () => {
    setLoading(true);
    setErrorMessages(null);
    try {
      const data = await form.validateFields();
      if (target?.id) {
        // await PUT(`${URL_SETTING.SELLER_RAW_LATEX}${target.id}/`, data); รอ api
      } else {
        // await POST(URL_SETTING.SELLER_RAW_LATEX, data); รอ api
      }
      onUpdate();
    } catch (error) {
      setErrorMessages(error.errorMessages);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      okText={target ? "แก้ไข" : "เพิ่ม"}
      cancelText="ยกเลิก"
      title={target ? "แก้ไขการนำเข้าน้ำยางข้น" : "นำเข้าน้ำยางข้น "}
      width={650}
      onOk={handleOK}
      destroyOnClose
      centered
      okButtonProps={{
        style: { backgroundColor: target ? colorWarning : colorSuccess },
        loading,
      }}
    >
      <ErrorMessages message={errorMessages} />
      <Form form={form} layout="vertical">
        <Row gutter={16}>
          <Col span={16}>
            <Form.Item
              label="บริษัทผู้นำเข้า"
              name="-"
              rules={[{ required: true, message: 'กรุณากรอกข้อมูล' }]}
            >
              <Input />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item label="ล็อตนำเข้า" name="-" rules={[{ required: true, message: 'กรุณากรอกข้อมูล' }]}>
              <Input />
            </Form.Item>
          </Col>
          <Col span={16}>
            <Form.Item label="สินค้า" name="-" rules={[{ required: true, message: 'กรุณากรอกข้อมูล' }]}>
              <Input />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              label="น้ำหนัก (Kg)"
              name="-"
              rules={[
                {
                  required: true,
                  message: 'กรุณากรอกข้อมูล'
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item label="%DRC" name="-" rules={[{ required: true, message: 'กรุณากรอกข้อมูล' }]}>
              <Input />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="ราคา/กก." name="-" rules={[{ required: true, message: 'กรุณากรอกข้อมูล' }]}>
              <Input />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="ราคารวม" name="-" rules={[{ required: true, message: 'กรุณากรอกข้อมูล' }]}>
              <Input />
            </Form.Item>
          </Col>
          <Divider>ข้อมูลปลายทาง</Divider>
          <Col span={12}>
            <Form.Item label="Lot No (ล็อตปลายทาง)" name="-" rules={[{ required: true, message: 'กรุณากรอกข้อมูล' }]}>
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="ใบแจ้งผลิต" name="-" rules={[{ required: true, message: 'กรุณากรอกข้อมูล' }]}>
              <Input />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
